export const versions = {
  assets: '4.17.0', // needs manual update when upgrading dependencies
  core: '7.84.0', // don't change. value is updated automatically
  fonts: '2.4.0', // needs manual update when upgrading dependencies
};
